// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"afc273b6","551":"2b1931ce","564":"027e7fb2","637":"a05773fb"}[chunkId] + ".css";
};